import React from "react";
import Carousel from "@christian-martins/react-grid-carousel";
import { Helmet } from 'react-helmet';

class About extends React.Component {
    render() {
        return (
            <div>
                <Helmet>
                    <title>About Aaysh Food Products | Coimbatore | Dehydrated vegetables | Spray dried fruits powder | Dried leaves and herbs | Spice Powders</title>
                </Helmet>
                <div className="breadcumb-wrapper" style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/breadcumb/breadcumb-bg-2.jpg)`,
                    backgroundSize: 'cover',
                }}>
                    <div className="container z-index-common">
                        <div className="breadcumb-content">
                            <h1 className="breadcumb-title">About Us</h1>
                            <div className="breadcumb-menu-wrap">
                                <ul className="breadcumb-menu">
                                    <li><a href="/">Home</a></li>
                                    <li>About Us</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <section className=" space-top space-extra-bottom">
  <div className="container">
    <div className="row gx-60">
      <div className="col-lg-6">
        <div className="img-box9">
          <div className="img-1">
            <img src="assets/img/about/about-9-1.jpg" alt="About Aayush Food" />
          </div>
          <div className="img-2">
            <img src="assets/img/about/about-9-2.jpg" alt="Aayush Food Products" />
          </div>
        </div>
      </div>
      <div className="col-lg-6">
        <span className="sec-subtitle">our stories</span>
        <h2 className="sec-title">Our Journey Was Start From 2012</h2>
        <p className="mb-30 pb-2">
        Founded in <b>2012</b> by <b>Mr. Kalaivendan Ramakrishnan</b> , Aayush Food Products began its journey as a proprietorship company with a clear vision – to deliver high-quality, natural, and reliable food ingredients to customers across the globe.
        </p>
        <p className="media-text">
           With humble beginnings, the company started by focusing on <b>dehydrated vegetables, spices, and food powders,</b> ensuring products that are rich in flavor, nutrition, and shelf stability. Over the years, our commitment to quality, innovation, and customer satisfaction has helped us grow steadily and earn the trust of clients in both domestic and international markets.
        </p>
      </div>
    </div>
  </div>
</section>

                <section className="space-top space-extra-bottom">
                    {/*<div className="shape-mockup jump-img d-none d-xl-block" data-left="34%" data-bottom="1%"><img src="assets/img/shape/leaf-1-6.png" alt="shape" /></div>*/}
                    <div className="container">
                        <div className="row justify-content-between gx-0 ">
                            <div className="col-md-10">
                                <span className="sec-subtitle">About Aayush Food Products</span>
                                <h4 className="h4 pe-xxl-5 me-xxl-5 mb-md-5 pb-xl-3">Founded in 2012 by Mr. Kalaivendan Ramakrishnan, Aayush Food Products began its journey as a proprietorship company with a clear vision – to deliver high-quality, natural, and reliable food ingredients to customers across the globe. </h4>
                            </div>
                            <div className="col-auto mb-5 mb-md-0">
                                <div className="pt-1 mt-2">
                                    <div className="circle-btn style2">
                                        <a href="service.html" className="btn-icon"><i className="far fa-arrow-right"></i></a>
                                        <div className="btn-text">
                                            <svg viewBox="0 0 150 150">
                                                <text>
                                                    <textPath href="#textPath">Aayush Food Products  |   Coimbatore |</textPath>
                                                </text>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p className="fs-md font-title text-title mb-4 mb-lg-5">With humble beginnings, the company started by focusing on <b>dehydrated vegetables, spices, and food powders,</b> ensuring products that are rich in flavor, nutrition, and shelf stability. Over the years, our commitment to quality, innovation, and customer satisfaction has helped us grow steadily and earn the trust of clients in both domestic and international markets.</p>
                        <p className="fs-md font-title text-title mb-4 mb-lg-5">At Aayush Food Products, we specialize in a wide range of <b>dehydrated vegetables, spray dried fruit & vegetable powders, dairy powders, and natural leaf herbs.</b> Each product is processed under strict quality standards, ensuring purity, hygiene, and consistent performance for food manufacturers, traders, and end users.</p>
                        <p className="fs-md font-title text-title mb-4 mb-lg-5">At Aayush Food Products, we specialize in a wide range of dehydrated vegetables, spray dried fruit & vegetable powders, dairy powders, and natural leaf herbs. Each product is processed under strict quality standards, ensuring purity, hygiene, and consistent performance for food manufacturers, traders, and end users.
</p>
                        <p className="fs-md font-title text-title mb-4 mb-lg-5">Our mission is – simple: to blend traditional taste with modern food processing techniques and provide ingredients that make everyday cooking easier, healthier, and more flavorful.</p>
                        <p className="fs-md font-title text-title mb-4 mb-lg-5">Today, Aayush Food Products stands as a trusted name in the food ingredient industry, driven by the values of integrity, quality, and continuous improvement.</p>

                        <blockquote className="vs-quote">
                            <p>
                                “Unlock the Flavor, Preserve the Nutrition. Elevate your cuisine with our premium range of dehydrated vegetables and spray-dried fruits powders. From the fields to your kitchen, we encapsulate nature's goodness, ensuring every meal is a testament to health and taste.”{" "}
                            </p>
                            <cite>Aayush Foods</cite>
                        </blockquote>
                        <div className="row justify-content-between">
                            
                            <div className="col-md-6 col-xl-6 wow fadeInUp" data-wow-delay="0.2s">
                                <div className="row gx-60">
                                    <div className="col-auto">
                                        <span className="about-number">01</span>
                                    </div> 
                                    <div className="col">
                                        <h4 className="fw-medium fs-26 font-body mt-n1 mb-lg-3 pb-lg-1">Our Mission</h4>
                                        <div className="list-style1">
                                            <p>To deliver high-quality, natural, and innovative food ingredients that enhance taste, nutrition, and convenience for customers worldwide. We aim to combine traditional flavors with modern processing techniques, ensuring consistency, purity, and customer satisfaction in every product.
</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-6 wow fadeInUp" data-wow-delay="0.3s">
                                <div className="row gx-60">
                                     <div className="col-auto">
                                        <span className="about-number">02</span>
                                    </div> 
                                    <div className="col">
                                        <h4 className="fw-medium fs-26 font-body mt-n1 mb-lg-3 pb-lg-1">Our Vision</h4>
                                        <div className="list-style1">
                                            <p> To be recognized as a global leader in dehydrated and spray-dried food ingredients by continuously innovating, expanding product variety, and maintaining uncompromising quality standards. We envision Aayush Food Products as a trusted partner for food businesses and households across the globe.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="inner-wrap1  ">
                            <div
                                className="row vs-carousel"
                                data-slide-show={3}
                                data-lg-slide-show={2}
                                data-md-slide-show={2}
                            >
                                <div className="col-xl-4">
                                    <div className="service-style2">
                                        <div className="vs-icon style3">
                                            <img src="assets/img/about/vission.png" alt="icon" />
                                        </div>
                                        <h3 className="service-title h5">Our Mission</h3>
                                        <div className="arrow-shape">
                                            <i className="arrow" />
                                            <i className="arrow" />
                                            <i className="arrow" />
                                            <i className="arrow" />
                                        </div>
                                        <p className="service-text">
                                        To deliver high-quality, natural, and innovative food ingredients that enhance taste, nutrition, and convenience for customers worldwide. We aim to combine traditional flavors with modern processing techniques, ensuring consistency, purity, and customer satisfaction in every product.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-xl-4">
                                    <div className="service-style2">
                                        <div className="vs-icon style3">
                                            <img src="assets/img/about/mission.png" alt="icon" />
                                        </div>
                                        <h3 className="service-title h5">Our Vision</h3>
                                        <div className="arrow-shape">
                                            <i className="arrow" />
                                            <i className="arrow" />
                                            <i className="arrow" />
                                            <i className="arrow" />
                                        </div>
                                        <p className="service-text">
                                        To be recognized as a global leader in dehydrated and spray-dried food ingredients by continuously innovating, expanding product variety, and maintaining uncompromising quality standards. We envision Aayush Food Products as a trusted partner for food businesses and households across the globe.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-xl-4">
                                    <div className="service-style2">
                                        <div className="vs-icon style3">
                                            <img src="assets/img/about/quality.png" alt="icon" />
                                        </div>
                                        <h3 className="service-title h5">Quality Policy</h3>
                                        <div className="arrow-shape">
                                            <i className="arrow" />
                                            <i className="arrow" />
                                            <i className="arrow" />
                                            <i className="arrow" />
                                        </div>
                                        <p className="service-text">
                                       Believing is the fact that there is no substitute for quality. Aayush Food Products have been vigorously trying to put in all our efforts to improve the
quality of our products.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <h3>Our Licence And Certificates </h3>
                            <Carousel cols={5} rows={1} gap={10} loop>
      <Carousel.Item>
        <img width="100%" src="assets/img/brand/7.jpg" alt="" />
      </Carousel.Item>
      <Carousel.Item>
        <img width="100%" src="assets/img/brand/6.jpg" alt=""/>
      </Carousel.Item>
      <Carousel.Item>
        <img width="100%" src="assets/img/brand/5.jpg" alt=""/>
      </Carousel.Item>
      <Carousel.Item>
        <img width="100%" src="assets/img/brand/4.jpg" alt=""/>
      </Carousel.Item>
      <Carousel.Item>
        <img width="100%" src="assets/img/brand/3.jpg" alt=""/>
      </Carousel.Item>
      <Carousel.Item>
        <img width="100%" src="assets/img/brand/2.jpg" alt=""/>
      </Carousel.Item>
      <Carousel.Item>
        <img width="100%" src="assets/img/brand/1.jpg" alt=""/>
      </Carousel.Item>
    </Carousel>
                            </div>
                        </div>




                    </div>
                </section>
            </div>
        )
    }
}

export default About;